module.exports = __webpack_public_path__ + "img/Slide2.4e1eb7f6.png";